// extracted by mini-css-extract-plugin
export default {"addViewerTextAndAdd":"addViewer_addViewerTextAndAdd__aoM0Y","addViewerButton":"addViewer_addViewerButton__oOP-F"};